export default "__VITE_ASSET__1fb19360__"